<div class="basket-info-container">
  <div class="content" *ngIf="device">
    <div class="basket-info" *ngIf="device.quote as quote">
      <div class="detail">
        <div class="label">{{ 'basket.cart.headline.changed' | translate }}</div>
        <div class="value">{{ quote.updatedTime | date:'dd.MM.yyyy HH:mm'}}</div>
      </div>
      <div class="detail">
        <div class="label">{{ 'basket.cart.headline.changedBy' | translate }}</div>
        <div class="value">{{ employee }}</div>
      </div>
      <div class="spacer"></div>
      <div class="actions">
        <div class="status-drop-down {{ avtiveOption }}">
          <kion-drop-down
            *ngIf="hasBuyerRole; else noBuyerRole"
            [options]="statusOptions"
            [showSelectedOption]="true"
            [showDropDownOnClick]="true"
            (selected)="updateStatus($event)"
          ></kion-drop-down>
          <ng-template #noBuyerRole>
            <kion-status-label
              [text]="'quote.status.' + avtiveOption | translate"
              [class]="avtiveOption"
              theme="large"
            ></kion-status-label>
          </ng-template>
        </div>
        <div class="burger-menu" tabindex="1" #dropDown (click)="toggleDropDown()" (blur)="closeDropDown()" *ngIf="hasBuyerRole || hasApproverRole">
          <img src="assets/icons/burger_menu_points_icon.png" alt="burger_menu_points_icon" title="burger_menu_points_icon" />
          <div class="content">
            <div class="item" (click)="deleteButtonClicked($event);">
              <span class="delete">{{ 'quote.button.delete' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
